'use strict';

const Swiper = require('swiper/bundle').Swiper;
var throttle = require('lodash/throttle');
const materialIcon = require('../materialIcon');
const ProductGalleryHelper = require('./productGalleryHelper');
const breakpoints = require('../breakpoints');
const imageUrl = require('../imageUrl');

const THUMBNAIL_WIDTH_CLASS = 'w-113p';
const VIDEO_POSITION_IN_IMAGES_LOOP = 1;

module.exports = function () {
    const productViewModal = document.getElementById('product-view-modal');
    if (!productViewModal) {
        return;
    }
    const productViewModalTriggerClass = 'js-product-view-modal-trigger';
    const productViewModalTriggerStateClass = 'triggered';
    const productViewGallery = productViewModal.querySelector('.js-product-view-gallery');
    const productViewGalleryImagesDisclaimer = productViewModal.querySelector('.js-product-view-gallery-images-disclaimer');
    let slideConfig;
    let selectedImagesArray;
    let productVideoIDsArray;
    let isMainProductGallery;
    let galleryStartIndex;
    let thumbnailGalleryStartIndex;
    let baseVideoUrl;
    let videoLabel;
    let imagesDisclaimerText;

    function renderProductViewGallery(images) {
        const swiperSlideBonusProductsIndex = 0;
        const swiperSlideBonusProductsHTML = document.querySelector('.js-product-gallery-wrapper .js-swiper-slide-bonus-products')?.innerHTML;
        const swiperSlideThumbnailBonusProductsHTML = document.querySelector('.js-product-gallery-thumbnails-wrapper .js-swiper-slide-bonus-products')?.innerHTML;

        const swiperSlideBundleProductsIndex = 0;
        const swiperSlideBundleProductsHTML = document.querySelector('.js-product-gallery-wrapper .js-swiper-slide-bundle-products')?.innerHTML;
        const swiperSlideThumbnailBundleProductsHTML = document.querySelector('.js-product-gallery-thumbnails-wrapper .js-swiper-slide-bundle-products')?.innerHTML;

        const swiperWrapperGallery = document.querySelector('.js-product-view-gallery .swiper-wrapper');
        const swiperWrapperThumbnailGallery = document.querySelector('.js-product-view-gallery-thumbnails .swiper-wrapper');
        const isProductVideoAvailable = productVideoIDsArray?.length;

        if (!swiperWrapperThumbnailGallery && !swiperWrapperGallery) {
            return;
        }

        const generateVideoSlide = (index, videoIndex) => {
            const html = `
            <div class="swiper-slide" data-swiper-slide-index="${index}">
                <div class="ratio ratio-1x1">
                    <iframe src="${baseVideoUrl}${productVideoIDsArray[videoIndex]}"
                        class="js-product-video"
                        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                        allowfullscreen="true">
                    </iframe>
                </div>
            </div>`;
            return html;
        };

        const generateVideoThumbnailSlide = (index) => {
            const html = `
            <div class="swiper-slide" data-swiper-slide-index="${index}">
                <div class="${THUMBNAIL_WIDTH_CLASS} ratio ratio-1x1">
                    <div class="d-flex flex-column gap-1 align-items-center justify-content-center">
                        <div>${materialIcon.play_circle_filled}</div>
                        <span class="small text-dark">${videoLabel}</span>
                    </div>
                </div>
            </div>`;
            return html;
        };

        const generateBonusProductSlide = (index) => {
            return (swiperSlideThumbnailBonusProductsHTML ? `
            <div class="swiper-slide" data-swiper-slide-index="${index}">
                <div class="swiper-slide-bonus-products-wrapper">
                    ${swiperSlideBonusProductsHTML}
                </div>
            </div>
            ` : '');
        };

        const generateBonusProductThumbnailSlide = (index) => {
            return (swiperSlideThumbnailBonusProductsHTML ? `
            <div class="swiper-slide" data-swiper-slide-index="${index}">
                <div class="${THUMBNAIL_WIDTH_CLASS} ratio ratio-1x1">
                    ${swiperSlideThumbnailBonusProductsHTML}
                </div>
            </div>
            ` : '');
        };

        const generateBundleProductSlide = (index) => {
            return (swiperSlideThumbnailBundleProductsHTML ? `
            <div class="swiper-slide" data-swiper-slide-index="${index}">
                <div class="swiper-slide-bundle-products-wrapper">
                    ${swiperSlideBundleProductsHTML}
                </div>
            </div>
            ` : '');
        };

        const generateBundleProductThumbnailSlide = (index) => {
            return (swiperSlideThumbnailBundleProductsHTML ? `
            <div class="swiper-slide" data-swiper-slide-index="${index}">
                <div class="${THUMBNAIL_WIDTH_CLASS}">
                    ${swiperSlideThumbnailBundleProductsHTML}
                </div>
            </div>
            ` : '');
        };

        const generateSlide = (imgArg, galleryStartIndexArg) => {
            return `
            <div class="swiper-slide" data-swiper-slide-index="${galleryStartIndexArg}">
                <div class="swiper-zoom-container">
                    <img src="${imageUrl.generateImageUrl(imgArg.mainImage, { sw: 768 })}"
                        alt="${imgArg.alt}"
                        sizes="(min-width: 1920px) 1946px,(min-width: 992px) 100vh,100vw"
                        srcset="${imageUrl.generateImageSrcSet(imgArg.mainImage, [442, 594, 688, 798, 1246, 1462, 1946, 2258])}"
                        width="1200" height="1200"
                        class="text-transparent"
                        loading="lazy"
                    />
                    <div class="js-swiper-slide-placeholder position-absolute top-0 start-0 end-0 bottom-0 bg-white d-flex align-items-center justify-content-center">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>
            </div>`;
        };

        const generateThumbnailSlide = (imgArg, thumbnailGalleryStartIndexArg) => {
            return `
            <div class="swiper-slide" data-swiper-slide-index="${thumbnailGalleryStartIndexArg}">
                <div class="w-113p img-wrapper-ratio-1x1">
                    <img src="${imageUrl.generateImageUrl(imgArg.mainImage, { sw: 113 })}"
                        alt="${imgArg.alt}"
                        sizes="113px"
                        srcset="${imageUrl.generateImageSrcSet(imgArg.mainImage, [113, 226])}"
                        width="113" height="113"
                        class="text-transparent"
                        loading="lazy"
                    />
                </div>
            </div>`;
        };

        // slides start

        const prependedMultiImageSlide = generateBundleProductSlide(swiperSlideBundleProductsIndex)
            || generateBonusProductSlide(swiperSlideBonusProductsIndex);

        const imageSlidesWithOneVideo = images.map((img, index) => {
            let videoHTML = '';
            // idea: prepend video at VIDEO_POSITION_IN_IMAGES_LOOP (if 1 => after 1st image)
            if (isProductVideoAvailable && index === VIDEO_POSITION_IN_IMAGES_LOOP) {
                videoHTML = generateVideoSlide(galleryStartIndex, 0);
                galleryStartIndex += 1;
            } else {
                videoHTML = '';
            }

            const html = generateSlide(img, galleryStartIndex);
            galleryStartIndex += 1;

            return `${videoHTML}${html}`;
        }).join('');

        let videoSlidesAtTheEndHTML = '';
        if (productVideoIDsArray?.length > 1) {
            videoSlidesAtTheEndHTML = productVideoIDsArray.map((_, index) => {
                if (index !== 0) {
                    let html = generateVideoSlide(galleryStartIndex, index);
                    galleryStartIndex += 1;
                    return html;
                }
                return '';
            }).join('');
        }

        swiperWrapperGallery.innerHTML = `
            ${prependedMultiImageSlide}
            ${imageSlidesWithOneVideo}
            ${videoSlidesAtTheEndHTML}
        `;

        // slides end

        // thumbnail start

        const thumbnailPrependedMultiImageSlide = generateBundleProductThumbnailSlide(swiperSlideBundleProductsIndex)
            || generateBonusProductThumbnailSlide(swiperSlideBonusProductsIndex);

        const thumbnailImageSlidesWithOneVideo = images.map((img, index) => {
            let videoThumbnailHTML = '';
            if (isProductVideoAvailable && index === VIDEO_POSITION_IN_IMAGES_LOOP) {
                videoThumbnailHTML = generateVideoThumbnailSlide(thumbnailGalleryStartIndex);
                thumbnailGalleryStartIndex += 1;
            } else {
                videoThumbnailHTML = '';
            }

            const html = generateThumbnailSlide(img, thumbnailGalleryStartIndex);
            thumbnailGalleryStartIndex += 1;

            return `${videoThumbnailHTML}${html}`;
        }).join('');

        let thumbnailVideoSlidesAtTheEndHTML = '';
        if (productVideoIDsArray?.length > 1) {
            thumbnailVideoSlidesAtTheEndHTML = productVideoIDsArray.map((_, index) => {
                if (index !== 0) {
                    let html = generateVideoThumbnailSlide(thumbnailGalleryStartIndex);
                    thumbnailGalleryStartIndex += 1;
                    return html;
                }
                return '';
            }).join('');
        }

        swiperWrapperThumbnailGallery.innerHTML = `
            ${thumbnailPrependedMultiImageSlide}
            ${thumbnailImageSlidesWithOneVideo}
            ${thumbnailVideoSlidesAtTheEndHTML}
        `;

        // thumbnail end

        if (imagesDisclaimerText && productViewGalleryImagesDisclaimer) {
            productViewGalleryImagesDisclaimer.innerHTML = `
            <div class="pe-none position-absolute bottom-100 left-0 right-0 m-1 z-5 d-flex justify-content-center bg-card">
                <div class="d-flex align-items-center gap-1 rounded text-body xx-small px-1">
                    <span class="material-icon-wrapper-x-small material-icon-wrapper-default svg-wrapper-inherit lh-1">${materialIcon.info}</span>
                    <span>${imagesDisclaimerText}</span>
                </div>
            </div>`;
        }
    }

    function handleProductViewModalTrigger(e) {
        const trigger = e.target.closest(`.${productViewModalTriggerClass}:not(.${productViewModalTriggerStateClass})`);
        if (trigger) {
            trigger.classList.add('triggered');
            selectedImagesArray = null;
            productVideoIDsArray = null;
            isMainProductGallery = null;
            galleryStartIndex = null;
            thumbnailGalleryStartIndex = null;
            baseVideoUrl = null;
            videoLabel = null;
            imagesDisclaimerText = null;
            try {
                slideConfig = JSON.parse(productViewGallery.getAttribute('slide-config'));
            } catch {
                return;
            }
            try {
                selectedImagesArray = JSON.parse(trigger.dataset.images);
            } catch {
                selectedImagesArray = [];
            }
            try {
                productVideoIDsArray = JSON.parse(trigger.dataset.productVideoIdsObject);
            } catch {
                productVideoIDsArray = [];
            }
            isMainProductGallery = trigger.dataset.isMainProductGallery === 'true';
            galleryStartIndex = parseInt(trigger.dataset.galleryStartIndex) || 0;
            thumbnailGalleryStartIndex = galleryStartIndex;
            baseVideoUrl = trigger.dataset.baseVideoUrl || '';
            videoLabel = trigger.dataset.videoLabel || '';
            imagesDisclaimerText = trigger.dataset.imagesDisclaimer || '';

            $('#product-view-modal').modal('show');
        }
    }

    document.addEventListener('click', handleProductViewModalTrigger);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            handleProductViewModalTrigger(e);
        }
    });

    $(document).on('shown.bs.modal', '#product-view-modal', function () {
        if (breakpoints.up('lg')) {
            const swiperWrapperGallery = document.querySelector('.js-product-view-gallery .swiper-wrapper');
            swiperWrapperGallery.style.width = `${window.innerWidth}px`;
            window.onresize = throttle(() => {
                swiperWrapperGallery.style.width = `${window.innerWidth + 10}px`;
            }, 100);
        }

        renderProductViewGallery(selectedImagesArray);

        const slideConfigDefault = {
            navigation: {
                nextEl: document.querySelector('.js-product-view-gallery .swiper-button-next'),
                prevEl: document.querySelector('.js-product-view-gallery .swiper-button-prev')
            }
        };

        if (('ontouchstart' in window)) {
            slideConfigDefault.zoom = {
                maxRatio: 2,
                minRatio: 1
            };
        }

        const productViewGallerySwiperElement = document.querySelector('.js-product-view-gallery .swiper');

        // eslint-disable-next-line no-new
        const swiperProductViewGalleryInstance = new Swiper(productViewGallerySwiperElement, { ...slideConfigDefault, ...slideConfig });

        swiperProductViewGalleryInstance.update();

        const productViewGallerySwiper = document.querySelector('.js-product-view-gallery .swiper').swiper;
        const swiperThumbModalSlides = document.querySelectorAll('.js-product-view-gallery-thumbnails .swiper-slide');

        const thumbnailEvents = window.matchMedia('(hover: hover)').matches ? ['click', 'mouseenter'] : ['click'];
        const productGalleryHelper = new ProductGalleryHelper(swiperThumbModalSlides, productViewGallerySwiper, thumbnailEvents);
        productGalleryHelper.bindEventsThumbnailSlides();

        const swiperProductGallery = document.querySelector('.js-product-gallery-thumbnails .swiper-slide-active-custom');
        let currentIndex = 0;

        if (isMainProductGallery) {
            currentIndex = parseInt(swiperProductGallery?.getAttribute('data-swiper-slide-index'), 10);
            productViewGallerySwiper.slideToLoop(parseInt(currentIndex));
        }

        const currentThumb = document.querySelector(`.js-product-view-gallery-thumbnails .swiper-slide[data-swiper-slide-index="${currentIndex}"]`);
        productGalleryHelper.setCurrentProductSlideAsSelectedThumbnail(currentThumb);

        productViewGallerySwiper.update();

        if (!('ontouchstart' in window)) {
            const productImages = document.querySelectorAll('.js-product-view-gallery img');

            productViewGallerySwiper.zoom.enabled = false;

            productGalleryHelper.clickImageToggleClassScrollIntoView(productImages, productViewGallery, 'fill');
            productViewGallery.classList.add('desktop-zoom-initialised');
        }

        productViewGallerySwiper.on('slideChange', () => {
            productViewGallery.classList.remove('fill');
            const selectedSlide = document.querySelector(`.js-product-view-gallery-thumbnails .swiper-slide[data-swiper-slide-index="${productViewGallerySwiper.realIndex}"]`);
            productGalleryHelper.setCurrentProductSlideAsSelectedThumbnail(selectedSlide);
            selectedSlide?.scrollIntoView({
                behavior: 'auto',
                block: 'start'
            });

            productGalleryHelper.pauseVideos();
        });
    });

    $(document).on('hidden.bs.modal', '#product-view-modal', function () {
        productViewGallery?.classList.remove('fill');
        productViewGalleryImagesDisclaimer.innerHTML = '';
        const productViewGallerySwiper = document.querySelector('#product-view-modal .swiper').swiper;
        productViewGallerySwiper?.destroy(true, true);
        document.querySelectorAll(`.${productViewModalTriggerClass}.${productViewModalTriggerStateClass}`).forEach(trigger => {
            trigger.classList.remove(productViewModalTriggerStateClass);
        });
    });
};
